import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './views/base/layout/layout.component';
import { HomeComponent } from "./views/auth/home/home.component";
import { ErrorModule, ErrorComponent, AuthGuard, IsLoggedIn } from "@school/a2z-lib";

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [IsLoggedIn],
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./views/auth/auth.module').then(m => m.AuthModule),
      }
    ],
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'v1',
        loadChildren: () => import('./views/content/content.module').then(m => m.ContentModule),
      }
    ],
  },
  { path: "error/403", component: ErrorComponent },
  { path: "**", redirectTo: "error/403", pathMatch: "full" },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
